/* Ever Well Health theme — vanilla JS (no dependencies) */
(function () {
  /* Header scroll state */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile menu */
  var burger = document.querySelector('[data-burger]');
  if (burger && header) {
    burger.addEventListener('click', function () {
      header.classList.toggle('menu-open');
      burger.setAttribute('aria-expanded', header.classList.contains('menu-open'));
    });
  }

  /* Hero slideshow */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    var counter = root.querySelector('[data-counter]');
    var i = 0;
    var show = function (n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' — ' + String(slides.length).padStart(2, '0');
    };
    slides[0].classList.add('is-active');
    var timer = setInterval(function () { show(i + 1); }, 6000);
    root.querySelectorAll('[data-prev]').forEach(function (b) {
      b.addEventListener('click', function () { clearInterval(timer); show(i - 1); });
    });
    root.querySelectorAll('[data-next]').forEach(function (b) {
      b.addEventListener('click', function () { clearInterval(timer); show(i + 1); });
    });
  });

  /* Scroll carousels (reviews etc.) */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var countEl = root.querySelector('[data-count]');
    var slides = track.children;
    var update = function () {
      if (!countEl || !slides.length) return;
      var w = track.clientWidth;
      var idx = Math.round(track.scrollLeft / w);
      countEl.textContent = String(Math.min(idx + 1, slides.length)).padStart(2, '0') + ' — ' + String(slides.length).padStart(2, '0');
    };
    track.addEventListener('scroll', update, { passive: true });
    update();
    root.querySelectorAll('[data-prev]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-next]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    });
  });

  /* Reveal on scroll */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  /* Discovery category filter */
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    var chips = group.querySelectorAll('[data-filter]');
    var cards = group.querySelectorAll('[data-category]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var f = chip.getAttribute('data-filter');
        cards.forEach(function (card) {
          card.style.display = (f === 'all' || card.getAttribute('data-category') === f) ? '' : 'none';
        });
      });
    });
  });
})();
